import axios from '../utils/axios';

const SERVICE_URL = '/users/client';

export const login = async (userForm) => {
    try {
        const userCart = JSON.parse(localStorage.getItem('userCart')) || null;
        let response = await axios.post(`${SERVICE_URL}/login`, { userForm, userCart });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const userCreate = async (data) => {
    try {
        let response = await axios.post(`${SERVICE_URL}/create`, data);
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : error;
    }
}

export const getUser = async (id) => {
    try {
        let response = await axios.post(`${SERVICE_URL}/id?id=${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const userEditAddress = async (item) => {
    try {
        let response = await axios.post(`${SERVICE_URL}/address`, item);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getPresignedUrlForCFDI = (userId) => {
    let route = `cfdi/${userId}`
    return axios.post(`${SERVICE_URL}/cfdi/pre-signed-url`, { route })
}
export const getPresignedUrlForTemporalCFDI = (cartId) => {
    let route = `cfdi/temporal/${cartId}`
    return axios.post(`${SERVICE_URL}/cfdi/pre-signed-url`, { route })
}

export const getPresignedUrlDownloadForCFDI = (userId) => {
    return axios.get(`${SERVICE_URL}/cfdi/pre-signed-url/${userId}`)
}

export const userUpdateCfdiStatus = (userId, cfdiUse) => {
    return axios.post(`${SERVICE_URL}/cfdi/update`, { id: userId, cfdiUse })
}

export const userConfirmSignUp = async (email, code) => {
    try {
        const response = await axios.post(`${SERVICE_URL}/confirm-signup`, { email, code });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const userResendConfirmationCode = async (email) => {
    try {
        const response = await axios.post(`${SERVICE_URL}/resend-confirmation-code`, { email });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const userRequestPasswordChange = async ({ email, currentPassword, newPassword }) => {
    try {
        const response = await axios.post(`${SERVICE_URL}/request-password-change`, {
            email,
            currentPassword,
            newPassword
        });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : error;
    }
}

export const userForgotPassword = async (email) => {
    try {
        const response = await axios.post(`${SERVICE_URL}/forgot-password`, { email });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : error;
    }
}

export const userConfirmForgotPassword = async ({ email, code, password }) => {
    try {
        const response = await axios.post(`${SERVICE_URL}/confirm-forgot-password`, {
            email,
            code,
            password
        });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : error;
    }
}